"use client"
import React, { useRef, useState, useEffect, Fragment } from "react";
import { Form, FormControl } from "react-bootstrap";

import useUtils from "@/components/shared/useUtils";
import "@/components/maps/MapLayerView.css";

const LayerView = ({ layer, checked, onToggle }) => {
  const utils = useUtils();
  const DEFAULT_COLOR = "0F839D";

  const [editing, setEditing] = useState(false);

  const [theLayer, setTheLayer] = useState(null);

  var layerLabel = useRef(null);

  useEffect(() => {
    if (layer) {
      setTheLayer(layer);
    }
  }, [layer]);

  if (theLayer) {
    return (
      <div className="map-layer" key={`layer-${theLayer.value}`}>
        <img
          className="layer-marker"
          src={utils.markerUrl(theLayer.layerMarkerRef ?? DEFAULT_COLOR, theLayer.icon, theLayer.shape ?? "PIN")}
          style={{ marginRight: "1rem" }}
        />

        <div className="d-flex flex-row justify-content-start align-items-center w-100">
          <span className={"layer-label" + (checked ? " checked" : "")}>
            {theLayer.label}
          </span>

          <div className="flex-grow-1" />

          <Form.Check
            className={"layer-switch" + (checked ? " checked" : "")}
            custom="true"
            type="switch"
            checked={checked}
            id={`${layer.value}-switch`}
            onClick={evt => {
              onToggle(layer.value, !checked);
            }}
            label=""
          />
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

const MapLayerView = ({ show, layers, onLayersSelected, onClose }) => {
  const [mapLayers, setMapLayers] = useState([]);
  const [selectedLayers, setSelectedLayers] = useState([]);

  useEffect(() => {
    if (layers) {
      setMapLayers(layers);
      setSelectedLayers(
        layers.map(layer => {
          return layer.value;
        })
      );
    }
  }, [layers]);

  const onSwitchToggled = (value, checked) => {
    // console.log("MapLayerView onSwitchToggled", value, checked);
    var newSelectedLayers = [...selectedLayers];
    if (checked) {
      var newSelectedLayers = [...selectedLayers];
      newSelectedLayers.push(value);
      // console.log(newSelectedLayers);
      onLayersSelected(newSelectedLayers);
    } else {
      var index = selectedLayers.findIndex(sl => sl === value);
      if (index > -1) {
        var newSelectedLayers = [...selectedLayers];
        newSelectedLayers.splice(index, 1);
        // console.log(newSelectedLayers);
        onLayersSelected(newSelectedLayers);
      }
    }
    setSelectedLayers(newSelectedLayers);
  };

  const createLayerComponent = layer => {
    var checked = selectedLayers.findIndex(sl => sl === layer.value) > -1;
    return (
      <LayerView layer={layer} checked={checked} onToggle={onSwitchToggled} />
    );
  };

  return (
    <div className={`map-layer-view ${show ? "show" : "hide"}`}>
      <div className="header" style={{ marginTop: 0, marginBottom: 0 }}>
        <h4>Layers</h4>
        <div className="flex-grow" />
        <div style={{ cursor: "pointer" }} onClick={onClose}>
          <i className="material-icons">close</i>
        </div>
      </div>
      {mapLayers && mapLayers.length > 0 && (
        <>
          {mapLayers.map((layer, index) => {
            return <Fragment key={index}>{createLayerComponent(layer)}</Fragment>;
          })}
        </>
      )}
    </div>
  );
};
export default MapLayerView;
